import React from 'react';

export default function AddUnitModal({ show, propertyType, onClose, form, onChange, onSave }) {
    if (!show) return null;
    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 overflow-y-auto">
            <div className="flex justify-center items-start p-4 sm:py-7 min-h-full">
            <div className="relative bg-white shadow-lg rounded-lg w-full max-w-lg">
                <div className="flex justify-between items-center px-6 py-4 border-b">
                    <h2 className="font-semibold text-xl">Add A New Unit</h2>
                    <button
                        type="button"
                        className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
                        onClick={onClose}
                        aria-label="Close add unit form"
                    >
                        &times;
                    </button>
                </div>
                <div className="p-6">
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        onSave();
                    }}
                >
                    <p className='lableName'>Unit Name</p>
                    <div className="input-icons">
                        <i className="fa fa-hashtag icon"></i>
                        <input
                            className="input-field"
                            type="text"
                            name="house_number"
                            value={form.house_number || ""}
                            onChange={onChange}
                            placeholder="Unit Number"
                            required
                        />
                    </div>
                    <p className='lableName'>Billing Type</p>
                    <select
                        className="input-field"
                        name="payment_type"
                        value={form.payment_type || "rent"}
                        onChange={onChange}
                        required
                    >
                        <option value="rent">Rent only</option>
                        <option value="service_charge">Service charge only</option>
                        <option value="rent_and_service_charge">Rent and service charge</option>
                    </select>
                    {form.payment_type !== "service_charge" && (
                        <>
                            <p className='lableName'>Unit Rent Amount</p>
                            <div className="input-icons">
                                <i className="fa fa-hashtag icon"></i>
                                <input
                                    className="input-field"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    name="rent"
                                    value={form.rent ?? ""}
                                    onChange={onChange}
                                    placeholder="Rent"
                                    required
                                />
                            </div>
                        </>
                    )}
                    {form.payment_type !== "rent" && (
                        <>
                            <p className='lableName'>Service Charge</p>
                            <div className="input-icons">
                                <i className="fa fa-hashtag icon"></i>
                                <input
                                    className="input-field"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    name="service_charge"
                                    value={form.service_charge ?? ""}
                                    onChange={onChange}
                                    placeholder="Service charge"
                                    required
                                />
                            </div>
                        </>
                    )}
                    <p className='lableName'>VAT Collection</p>
                    <select className="input-field" name="vat_option" value={form.vat_option || "none"} onChange={onChange}>
                        <option value="none">No VAT</option>
                        <option value="preset">Preset VAT (16%)</option>
                        <option value="custom">Enter a specific VAT amount</option>
                    </select>
                    {form.vat_option === "custom" && (
                        <div className="input-icons mt-2">
                            <i className="fa fa-hashtag icon"></i>
                            <input className="input-field" type="number" min="0" step="0.01" name="vat_amount"
                                value={form.vat_amount ?? ""} onChange={onChange} placeholder="VAT amount" required />
                        </div>
                    )}
                    <span className="block text-sm text-gray-500 mt-1">
                        Rent, service charge and VAT may each contain up to two decimal places.
                    </span>
                    <p className='lableName'>Payment Frequency</p>
                    <select
                        className="input-field"
                        name="generate_invoice_schedule"
                        value={form.generate_invoice_schedule || "monthly"}
                        onChange={onChange}
                        required
                    >
                        <option value="monthly">Monthly</option>
                        <option value="quarterly">Quarterly</option>
                        <option value="semi-annual">Semi-Annually</option>
                        <option value="annually">Annually</option>
                    </select>
                    <p className='lableName'>Unit Due Date</p>
                    <div className="input-icons">
                        <i className="fa fa-hashtag icon"></i>
                        <input
                            className="input-field"
                            type="date"
                            name="due_date"
                            value={form.due_date || ""}
                            onChange={onChange}
                            placeholder="Due Date"
                            required
                        />
                    </div>
                    {propertyType !== "comercial" && (
                        <>
                            <p className='lableName'>No of Bedrooms</p>
                            <div className="input-icons">
                                <i className="fa fa-hashtag icon"></i>
                                <input
                                    className="input-field"
                                    type="number"
                                    name="bedroom"
                                    value={form.bedroom || ""}
                                    onChange={onChange}
                                    placeholder="Bedroom"
                                    required
                                />
                            </div>
                            <p className='lableName'>No of Bathrooms</p>
                            <div className="input-icons">
                                <i className="fa fa-hashtag icon"></i>
                                <input
                                    className="input-field"
                                    type="number"
                                    name="bathroom"
                                    value={form.bathroom || ""}
                                    onChange={onChange}
                                    placeholder="Bathroom"
                                    required
                                />
                            </div>
                            <p className='lableName'>Total rooms</p>
                            <div className="input-icons">
                                <i className="fa fa-hashtag icon"></i>
                                <input
                                    className="input-field"
                                    type="number"
                                    name="total_rooms"
                                    value={form.total_rooms || ""}
                                    onChange={onChange}
                                    placeholder="Total Rooms"
                                    required
                                />
                            </div>
                        </>
                    )}
                    <p className='lableName'>About Unit</p>
                    <div className="input-icons">
                        <i className="fa fa-hashtag icon"></i>
                        <input
                            className="input-field"
                            type="text"
                            name="about"
                            value={form.about || ""}
                            onChange={onChange}
                            placeholder="About Unit"
                            required
                        />
                    </div>
                    <p className='lableName'>Unit Deposit Amount</p>
                    <div className="input-icons">
                        <i className="fa fa-hashtag icon"></i>
                        <input
                            className="input-field"
                            type="number"
                            name="deposit"
                            value={form.deposit || ""}
                            onChange={onChange}
                            placeholder="Deposit"
                            required
                        />
                    </div>
                    <button type="submit" className="nextBtn  text-white  mt-3">
                        Save
                    </button>
                </form>
                </div>
            </div>
            </div>
        </div>
    );
}
